import { Refund } from '../NewModal';

export function getSurchargeRefundAmount(refund: Refund) {
  if (refund.has_surcharge) {
    return refund.surcharge_metadata.cash_amount;
  }

  return 0;
}
